export default __webpack_public_path__ + "static/media/2456.d7239f1a.png";